import React from 'react';
import { useNavigate } from 'react-router-dom';

const ViewBucket = ({
  bucketProducts = {},
  imageUrl = '',
  bucketRef,
  onViewBucket,
  navigationState = {},
  isSnackbarVisible = false,
  isFooterAvailable = false
}) => {
  const navigate = useNavigate();

  // Convert bucketProducts object → array
  const bucketItems = Object.values(bucketProducts).filter(p => p.quantity > 0);

  // Don’t render if no items
  if (bucketItems.length === 0) {
    return null;
  }

  const handleViewBucket = () => {
    if (onViewBucket) {
      // Custom handler if provided
      onViewBucket();
    } else {   
      // Navigate with optional state
      navigate(
        '/consumer/cartpreview',
        navigationState.state ? { state: navigationState.state } : {}
      );
    }
  };

 // Corrected bottom positioning logic
  let bottomPosition = 'bottom-4'; // Default
  if (isSnackbarVisible) {
    bottomPosition = 'bottom-40';
  } else if (isFooterAvailable) {
    bottomPosition = 'bottom-20';
  }

  return (
    <div
      ref={bucketRef}
      className={`fixed ${bottomPosition} inset-x-0 z-50 flex justify-center px-4 transition-all duration-300`}
    >
      <button
        onClick={handleViewBucket}
        className="flex items-center bg-red-500 text-white px-4 py-2.5 rounded-full shadow-lg hover:bg-red-600 transition-all relative"
        style={{ maxWidth: '90vw' }}
      >
        {/* Show up to 3 product images */}
        <div className="flex items-center relative mr-3" style={{ height: 28 }}>
          {bucketItems.slice(0, 3).map((product, index) => (
            <img
              key={product._id}
              src={`${imageUrl}${product.product_image || ''}`}
              alt={product.product_name || 'Product'}
              className="w-8 h-6 rounded-full object-cover border-2 border-white bg-gray-200"
              style={{
                position: 'absolute',
                left: `${index * 16}px`,
                zIndex: 10 - index,
              }}
            />
          ))}

          {/* Show count if more than 3 unique products */}
          {bucketItems.length > 3 && (
            <span
              className="w-6 h-6 rounded-full bg-gray-700 text-white text-xs font-semibold border-2 border-white flex items-center justify-center"
              style={{
                position: 'absolute',
                left: `${3 * 16}px`,
                zIndex: 1,
              }}
            >
              +{bucketItems.length - 3}
            </span>
          )}

          <span style={{ width: `${Math.min(bucketItems.length, 4) * 16 + 8}px` }} />
        </div>

        <div className="w-px h-6 bg-red-300 mr-3"></div>

        {/* Text content */}
        <div className="flex flex-col items-start">
          <span className="text-sm font-semibold leading-tight">View Bucket</span>
          <span className="text-xs opacity-90">
            {bucketItems.length} item{bucketItems.length > 1 ? 's' : ''}
          </span>
        </div>

        <svg className="w-4 h-4 ml-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
};

export default ViewBucket;
